<template>
    <div>
        <div class="pl-3 pr-3 border-solid border-gray-200 border-2">
            <v-tabs background-color="indigo" dark v-model="tab">
                <v-tab key="1">
                    Partner Info
                </v-tab>
                <v-tab key="2">
                    Operators
                </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
                <v-tab-item key="1">
                    <v-form ref="myform" v-model="isformvalid">
                        <v-jsf v-model="formmodel" :schema="formschema" :options="formoptions">
                            <template slot="bpowner" slot-scope="context">
                                <v-text-field v-bind="context" v-model="formmodel.bpowner" ref="fldfirst" maxlength="255" :readonly="fieldlocked"></v-text-field>
                            </template>
                            <template slot="bpcompany" slot-scope="context">
                                <v-text-field v-bind="context" v-model="formmodel.bpcompany" maxlength="255" :readonly="fieldlocked"></v-text-field>
                            </template>
                            <template slot="bpcontactno" slot-scope="context">
                                <v-text-field v-bind="context" v-model="formmodel.bpcontactno" maxlength="15" :readonly="fieldlocked"></v-text-field>
                            </template>
                            <template slot="bpaddr1" slot-scope="context">
                                <v-text-field v-bind="context" v-model="formmodel.bpaddr1" maxlength="255" :readonly="fieldlocked"></v-text-field>
                            </template>
                            <template slot="bpaddr2" slot-scope="context">
                                <v-text-field v-bind="context" v-model="formmodel.bpaddr2" maxlength="255" :readonly="fieldlocked"></v-text-field>
                            </template>
                            <template slot="bpaddr3" slot-scope="context">
                                <v-text-field v-bind="context" v-model="formmodel.bpaddr3" maxlength="255" :readonly="fieldlocked"></v-text-field>
                            </template>
                            <template slot="bpcity" slot-scope="context">
                                <v-text-field v-bind="context" v-model="formmodel.bpcity" maxlength="150" :readonly="fieldlocked"></v-text-field>
                            </template>
                            <template slot="bpstate" slot-scope="context">
                                <v-text-field v-bind="context" v-model="formmodel.bpstate" maxlength="50" :readonly="fieldlocked"></v-text-field>
                            </template>
                            <template slot="bppostcode" slot-scope="context">
                                <v-text-field v-bind="context" v-model="formmodel.bppostcode" maxlength="5" :readonly="fieldlocked"></v-text-field>
                            </template>
                        </v-jsf>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" dark @click="newItem" v-if="mode === ''">
                                <v-icon left>mdi-text-box-plus-outline</v-icon>
                                New
                            </v-btn>
                            <v-btn color="blue darken-3" dark @click="savethis" v-if="mode !== ''">
                                <v-icon left>mdi-content-save</v-icon>
                                Update
                            </v-btn>
                            <v-btn color="red darken-3" dark @click="cancel" v-if="mode != ''">
                                <v-icon left>mdi-close</v-icon>
                                Cancel
                            </v-btn>
                        </v-card-actions>
                    </v-form>
                </v-tab-item>
                <v-tab-item key="2">
                    <v-data-table :headers="opheaders" :items="dataops" disable-pagination hide-default-footer no-data-text="No record" no-results-text="No record" dense>
                        <template v-slot:top>
                            <v-toolbar flat color="white">
                                <v-toolbar-title>{{ editeditem.bpcompany }} Operators</v-toolbar-title>
                                <v-divider class="mx-4" inset vertical></v-divider>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" dark class="mb-2" @click="newOperator()" v-if="!fieldlocked && (mode === 'EDIT')">
                                    <v-icon left>mdi-text-box-plus-outline</v-icon>
                                    New Operator
                                </v-btn>
                            </v-toolbar>
                        </template>
                        <template v-slot:[`item.no`]="{ item }">
                            <small>{{ dataops.indexOf(item) + 1 }}</small>
                        </template>
                        <template v-slot:[`item.name`]="{ item }">
                            <small>{{ item.name }}</small>
                        </template>
                        <template v-slot:[`item.email`]="{ item }">
                            <small>{{ item.email }}</small>
                        </template>
                        <template v-slot:[`item.contactno`]="{ item }">
                            <small>{{ item.contactno }}</small>
                        </template>
                        <template v-slot:[`item.actions`]="{ item }">
                            <v-icon color="black" small @click="removeOperator(item)">mdi-delete</v-icon>
                        </template>
                    </v-data-table>
                </v-tab-item>
            </v-tabs-items>
        </div>
        <div class="pa-4 mt-3 border-solid border-gray-200 border-2">
            <v-data-table dense
                :headers="headers"
                :items="filtereddata()"
                item-key="id"
                v-model="selecteditems"
                show-select
                disable-pagination
                hide-default-footer
                no-data-text="No record"
                no-results-text="No record"
            >
                <template v-slot:[`header.bpowner`]="{ header }">
                    {{ header.text }}
                    <v-menu offset-y :close-on-content-click="false" min-width="300">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on">
                                <v-icon small :color="txtbpowner ? 'primary' : ''">mdi-filter</v-icon>
                            </v-btn>
                        </template>
                        <div class="bg-white pa-2">
                            <v-text-field v-model="txtbpowner" label="Owner" outlined></v-text-field>
                            <v-btn @click="txtbpowner = ''" small text color="primary" class="ml-2 mb-2">Clear</v-btn>
                        </div>
                    </v-menu>
                </template>
                <template v-slot:[`header.bpcompany`]="{ header }">
                    {{ header.text }}
                    <v-menu offset-y :close-on-content-click="false" min-width="300">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on">
                                <v-icon small :color="txtbpcompany ? 'primary' : ''">mdi-filter</v-icon>
                            </v-btn>
                        </template>
                        <div class="bg-white pa-2">
                            <v-text-field v-model="txtbpcompany" label="Company" outlined></v-text-field>
                            <v-btn @click="txtbpcompany = ''" small text color="primary" class="ml-2 mb-2">Clear</v-btn>
                        </div>
                    </v-menu>
                </template>
                <template v-slot:[`item.no`]="{ item }">
                    <small>{{ dataitems.indexOf(item) + 1 }}</small>
                </template>
                <template v-slot:[`item.bpowner`]="{ item }">
                    <small>{{ item.bpowner }}</small>
                </template>
                <template v-slot:[`item.bpcompany`]="{ item }">
                    <small>{{ item.bpcompany }}</small>
                </template>
                <template v-slot:[`item.bpoptotal`]="{ item }">
                    <small>{{ item.bpoptotal }}</small>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                    <v-icon class="mr-2" small color="black" @click="editItem(item)">mdi-pencil</v-icon>
                    <v-icon color="black" small @click="deleteItem(item)">mdi-delete</v-icon>
                </template>
                <template v-slot:[`body.append`]>
                    <td colspan="6">
                        <v-select class="w-40 mt-3" :items="multifunctions" item-value="type" item-text="name" v-model="selmultifunc" placeholder="Bulk Operation" @change="execmfunc" dense/>
                    </td>
                </template>
            </v-data-table>
            <v-dialog v-model="dlgnewop" width="450" dense>
                <v-card dense>
                    <v-toolbar flat color="indigo darken-2" dark dense>
                        <v-toolbar-title>New Operator</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn dark icon @click="dlgnewop = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-card-text class="mt-2">
                        <v-autocomplete prepend-icon="mdi-account-multiple" v-model="newop_item.opid" :items="datausers" item-value="id" item-text="name"></v-autocomplete>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn dark color="primary" @click="addOperator()">
                            Add
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dlgdelete" width="450" dark dense>
                <v-card dense>
                    <v-card-title class="title"><span class="text-white">Delete this record?</span></v-card-title>
                    <v-card-text>
                        <v-row dense>
                            <v-col cols="4">No.</v-col>
                            <v-col cols="8">{{ deleteditem.no }}</v-col>
                            <v-col cols="4">Owner</v-col>
                            <v-col cols="8">{{ deleteditem.bpowner }}</v-col>
                            <v-col cols="4">Company</v-col>
                            <v-col cols="8">{{ deleteditem.bpcompany }}</v-col>
                            <v-col cols="4">Total Operators</v-col>
                            <v-col cols="8">{{ deleteditem.bpoptotal }}</v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-3" dark @click="deletethis()">
                            <v-icon left>mdi-delete</v-icon>
                            Delete
                        </v-btn>
                        <v-btn color="red darken-3" dark @click="canceldelete()">
                            <v-icon left>mdi-close</v-icon>
                            Cancel
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
        <v-snackbar v-model="sbmsg" timeout="5000" color="green darken-4" dark centered>
            <div v-html="msg"></div>
            <template v-slot:action="{ attrs }">
                <v-btn color="white" text v-bind="attrs" @click="sbmsg = false">
                    Close
                </v-btn>
            </template>
        </v-snackbar>
        <v-snackbar v-model="sberrmsg" timeout="5000" color="red darken-4" dark centered>
            <div v-html="msg"></div>
            <template v-slot:action="{ attrs }">
                <v-btn color="white" text v-bind="attrs" @click="sberrmsg = false">
                    Close
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
const axios = require('axios')
import GeneralOptions from '../Forms/GeneralOptions'
import BizPartnersModel from '../Forms/BizPartnersModel'
import BizPartnersSchema from '../Forms/BizPartnersSchema'

export default {
    name: 'TableBizPartners',
    components: {},
    props: {},
    data() {
        return {
            isformvalid: false,
            formoptions: GeneralOptions,
            formmodel: BizPartnersModel,
            formschema: BizPartnersSchema,
            dataitems: [],
            headers: [
                { text: "No.",              value: "no",        sortable: false, align: "start", width: '40px' },
                { text: "Company",          value: "bpcompany", sortable: false },
                { text: "Owner",            value: "bpowner",   sortable: false },
                { text: "Total Operators",  value: "bpoptotal", sortable: false },
                { text: "Operations",       value: "actions",   sortable: false, align: 'end', width: '100px' }
            ],
            mode: null,
            editeditem: {
                no: 0,
                id: 0,
                bpowner: '',
                bpcompany: '',
                bpcontactno: '',
                bpaddr1: '',
                bpaddr2: '',
                bpaddr3: '',
                bpcity: '',
                bpstate: '',
                bppostcode: '',
                bpownerid: '',
            },
            deleteditem: {
                no: 0,
                id: 0,
                bpowner: '',
                bpcompany: '',
                bpcontactno: '',
                bpaddr1: '',
                bpaddr2: '',
                bpaddr3: '',
                bpcity: '',
                bpstate: '',
                bppostcode: '',
                bpownerid: '',
            },
            newitem: {
                bpowner: '',
                bpcompany: '',
                bpcontactno: '',
                bpaddr1: '',
                bpaddr2: '',
                bpaddr3: '',
                bpcity: '',
                bpstate: '',
                bppostcode: '',
                bpownerid: '',
            },
            dlgdelete: false,
            dlgnewop: false,
            sbmsg: false,
            sberrmsg: false,
            msg: '',
            selecteditems: [],
            multifunctions: [
                // multi selection functions
                { type: null, name: 'Bulk Operation' }, // default
                { type: 'MDEL', name: 'Delete selected' },
            ],
            selmultifunc: null,
            ismounted: false,
            fieldlocked: false,
            txtbpowner: '',
            txtbpcompany: '',
            tab: 0,
            opheaders: [
                { text: "No.",          value: "no",        sortable: false, align: "start", width: '40px' },
                { text: "Name",         value: "name",      sortable: false },
                { text: "QID No.",      value: "icno",      sortable: false },
                { text: "Email",        value: "email",     sortable: false },
                { text: "Contact No.",  value: "contactno", sortable: false },
                { text: "Operations",   value: "actions",   sortable: false, align: 'end', width: '100px' }
            ],
            dataops: [],
            datausers: [],
            databpusers: [],
            newop_item: {
                bpid: null,
                opid: null,
            },
            editedop_item: {
                id: null,
                bpid: null,
                opid: null,
            },
            deletedop_item: {
                id: null,
                bpid: null,
                opid: null,
            },
        }
    },
    watch: {
        mode: function (newval, oldval) {
            if (newval === '')  {
                // lock the form entry
                this.lockallfields(true)
                return
            }
            if (((newval === 'NEW') || (newval === 'EDIT')) && (oldval === '')) {
                // unlock the form entry
                this.lockallfields(false)
                return
            }
        }
    },
    mounted: function () {
        this.initialize()
    },
    methods: {
        lockallfields(pSwitch) {
            this.fieldlocked = pSwitch // any custom field
            const vjsfprops = this.formschema.properties
            for (const field in vjsfprops) {
                if (vjsfprops[field]['x-props']) {
                    vjsfprops[field]['x-props']['readonly'] = pSwitch
                }
            }
        },

        initialize() {
            this.$nextTick(() => {
                this.getdata()
                this.ismounted = true
                this.mode = ''
                this.editeditem = Object.assign({}, this.newitem)
                this.formmodel = Object.assign({}, this.newitem)
                this.selecteditems = []
                this.multifunc = ''

                this.txtbpowner = ''
                this.txtbpcompany = ''
            })
        },

        getdata() {
            var targetPath = '/admin/business-partners/all'
            axios.get(targetPath)
            .then((resp) => {
                if (resp.data) {
                    var rtn = resp.data
                    if (rtn.status === 'OK') {
                        this.dataitems = rtn.data
                    } else {
                        this.dataitems = []
                    }
                }
            })
        },

        filtereddata() {
            var conditions = []

            if (this.txtbpowner) { conditions.push(this.filterbpowner) }
            if (this.txtbpcompany) { conditions.push(this.filterbpcompany) }

            if (conditions.length > 0) {
                return this.dataitems.filter((item) => {
                    return conditions.every((condition) => {
                        return condition(item)
                    })
                })
            }

            return this.dataitems
        },

        filterbpowner(item) {
            return (item.bpowner) ? item.bpowner.toLowerCase().includes(this.txtbpowner.toLowerCase()) : null
        },

        filterbpcompany(item) {
            return (item.bpcompany) ? item.bpcompany.toLowerCase().includes(this.txtbpcompany.toLowerCase()) : null
        },

        newItem() {
            this.editeditem = Object.assign({}, this.newitem)
            this.formmodel = Object.assign({}, this.newitem)
            this.mode = 'NEW'
            this.$refs.fldfirst.focus()
        },

        editItem(itm) {
            this.editeditem = Object.assign({}, itm)
            this.formmodel = Object.assign({}, itm)
            this.mode = 'EDIT'
            this.$refs.fldfirst.focus()
            this.getOperators()
        },

        deleteItem(itm) {
            this.deleteditem = Object.assign({}, itm)
            this.deleteditem.no = this.dataitems.indexOf(itm) + 1
            this.dlgdelete = true
        },

        canceldelete() {
            this.deleteditem = Object.assign({}, this.newitem)
            this.dlgdelete = false
        },

        cancel() {
            this.formmodel = Object.assign({}, this.newitem)
            this.editeditem = Object.assign({}, this.newitem)
            this.datausers = []
            this.dataops = []
            this.mode = ''
        },

        savethis() {
            var targetPath = ''

            if (!this.isformvalid) {
                this.msg = 'Data invalid. Cannot continue with add or update.'
                this.sberrmsg = true
                this.cancel()
                return
            }

            var data = new FormData()
            if (this.mode === 'NEW') {
                targetPath = '/admin/business-partners/add'
            }

            if (this.mode === 'EDIT') {
                targetPath = '/admin/business-partners/update'
                data.append('id', this.editeditem.id)
            }

            data.append('bpowner', this.formmodel.bpowner)
            data.append('bpcompany', this.formmodel.bpcompany)
            data.append('bpcontactno', this.formmodel.bpcontactno)
            data.append('bpaddr1', this.formmodel.bpaddr1)
            data.append('bpaddr2', this.formmodel.bpaddr2)
            data.append('bpaddr3', this.formmodel.bpaddr3)
            data.append('bpcity', this.formmodel.bpcity)
            data.append('bpstate', this.formmodel.bpstate)
            data.append('bppostcode', this.formmodel.bppostcode)
            data.append('bpownerid', this.formmodel.bpownerid)

            axios.post(targetPath, data)
            .then((resp) => {
                if (resp.data) {
                    var rtn = resp.data
                    if (rtn.status === 'OK') {
                        this.msg = rtn.message
                        this.sbmsg = true
                        this.initialize()
                    } else {
                        this.msg = rtn.error
                        this.sberrmsg = true
                        this.cancel()
                    }
                }
            })

        },

        deletethis() {
            var targetPath = '/admin/business-partners/delete'
            var data = {
                id: this.deleteditem.id,
            }

            axios.post(targetPath, data)
            .then((resp) => {
                if (resp.data) {
                    var rtn = resp.data
                    this.canceldelete()
                    if (rtn.status === 'OK') {
                        this.msg = rtn.message
                        this.sbmsg = true
                        this.initialize()
                    } else {
                        this.msg = rtn.error
                        this.sberrmsg = true
                    }
                }
            })
        },

        deleteselected() {
            var targetPath = '/admin/business-partners/deleteselected'
            var data = new FormData()

            data.append('todelete', JSON.stringify(this.selecteditems))

            axios.post(targetPath, data, {
                headers: {
                    'ContentType': 'application/json' // coz we're passing an array
                }
            })
            .then((resp) => {
                if (resp.data) {
                    var rtn = resp.data
                    if (rtn.status === 'OK') {
                        this.initialize()
                        this.msg = rtn.message
                        this.sbmsg = true
                    } else {
                        this.msg = rtn.error
                        this.sberrmsg = true
                    }
                    this.$nextTick(() => {
                        this.selmultifunc = null // reset
                        this.selecteditems = [] // reset
                    })
                }
            })
        },

        execmfunc() {
            if (this.selmultifunc === 'MDEL') { // multiple delete
                // check if anything was selected
                if (this.selecteditems.length === 0) {
                    this.msg = 'No records are selected for deletion'
                    this.sberrmsg = true
                    this.$nextTick(() => {
                        this.selmultifunc = null // reset
                    })
                    return
                }
                this.deleteselected()
            }
        },

        getOperators() {
            var targetPath = '/admin/business-partners/operators'
            var data = {
                bpid: this.editeditem.id
            }
            axios.post(targetPath, data)
            .then((resp) => {
                if (resp.data) {
                    var rtn = resp.data
                    if (rtn.status === 'OK') {
                        this.dataops = rtn.data
                    } else {
                        this.dataops = []
                    }
                }
            })
        },

        newOperator() {
            var targetPath = '/admin/business-partners/all-users'
            axios.get(targetPath)
            .then((resp) => {
                if (resp.data) {
                    var rtn = resp.data
                    if (rtn.status === 'OK') {
                        this.datausers = rtn.data
                    } else {
                        this.datausers = []
                    }
                    this.dlgnewop = true
                }
            })
        },

        addOperator() {
            var targetPath = '/admin/business-partners/addoperator'
            var data = new FormData()

            data.append('bpid', this.editeditem.id)
            data.append('opid', this.newop_item.opid)

            axios.post(targetPath, data)
            .then((resp) => {
                if (resp.data) {
                    var rtn = resp.data
                    if (rtn.status === 'OK') {
                        this.getOperators()
                        this.dlgnewop = false
                    } else {
                        this.msg = rtn.error
                        this.sberrmsg = true
                    }
                }
            })
        },

        removeOperator(pItem) {
            var targetPath = '/admin/business-partners/removeoperator'
            var data = new FormData()

            data.append('id', pItem.id)

            axios.post(targetPath, data)
            .then((resp) => {
                if (resp.data) {
                    var rtn = resp.data
                    if (rtn.status === 'OK') {
                        this.getOperators()
                    } else {
                        this.msg = rtn.error
                        this.sberrmsg = true
                    }
                }
            })
        },

    },
}
</script>
